import React, { Component } from "react";
import MaterialTable from "material-table";
import UiUtils from "../../../provider/UiUtils";
import { withRouter } from "../../../withRouter";
import FetchServerData from "../../../provider/FetchServerData";
import { Card, CardBody } from "reactstrap";
import store from "../../../redux/store";
import PrintRoundedIcon from "@material-ui/icons/PrintRounded";
import ReactToPrint from "react-to-print";
import Button from "@material-ui/core/Button";
import Utils from "../../../provider/Utils";

class SupplierReportList extends Component {
  header = store.getState().header.header;
  constructor() {
    super();
    this.componentRef = React.createRef();
    this.state = {
      initialPage: 0,
      pageSize: 10,
      supplierList: [],
      isPaging: false,
      render: false,
    };
    this.getSupplierList();
  }
  getSupplierList() {
    const postObject = {
      header: this.header,
    };

    FetchServerData.callPostService("/misms/supplierList", postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          let supplierList = output.data.supplierList;
          let isPaging = false;
          if (supplierList.length > this.state.pageSize) {
            isPaging = true;
          }

          this.setState({
            render: true,
            isPaging: isPaging,
            supplierList: supplierList,
            initialPage: this.state.initialPage,
          });
        } 
      }
    );
  }

  render() {
    if (this.state.render === false) {
      return <div />;
    } else {
      return (
        <>
          {this.state.supplierList.length > 0 ? (
            <>
              <div className="row pe-2">
                <div className="col-md-12 text-end p-2">
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        variant="contained"
                        size="small"
                        id="printBtn"
                        style={{
                          background: "#0577ab",
                          color: "#fff",
                          padding: "7px",
                          width: "100px",
                        }}
                        startIcon={<PrintRoundedIcon />}
                      >
                        print
                      </Button>
                    )}
                    content={() => this.componentRef}
                  />
                </div>
              </div>
              <div style={{ maxWidth: "100%" }}>
                <MaterialTable
                  title="Supplier List"
                  tableRef={(el) => (this.componentRef = el)}
                  icons={UiUtils.getMaterialTableIcons()}
                  localization={{
                    body: {
                      emptyDataSourceMessage: "Please add Supplier",
                    },
                  }}
                  columns={[
                    {
                      title: "#",
                      render: (rowData) => rowData.tableData.id + 1,
                      width: "5%",
                      align: "left",
                      cellStyle: {
                        width: "6%",
                      },
                    },
                    {
                      title: "Name",
                      field: "name",
                      cellStyle: {
                        width: "18%",
                      },
                    },
                    {
                      title: "Type",
                      field: "type",
                      cellStyle: {
                        width: "15%",
                      },
                    },
                    {
                      title: "GSTN",
                      field: "gstn",
                      cellStyle: {
                        width: "18%",
                      },
                    },
                    {
                      title: "Address",
                      field: "address",
                      cellStyle: {
                        width: "30%",
                      },
                    },
                    {
                      title: "Status",
                      field: "status",
                    },
                  ]}
                  data={this.state.supplierList}
                  options={{
                    sorting: true,
                    search: false,
                    actionsColumnIndex: -1,
                    initialPage: this.state.initialPage,
                    pageSize: this.state.pageSize,
                    pageSizeOptions: Utils.materialTablePageSize(),
                    paging: this.state.isPaging,
                    headerStyle: {
                      backgroundColor: "#0B6F9D",
                      fontWeight: "bold",
                      color: "#ffff",
                      align: "left",
                    },
                  }}
                />
              </div>
            </>
          ) : (
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <div className="row">
                      <div className="col-md-12" style={{ padding: "2em" }}>
                        <h5>
                          <b>Supplier not created yet</b>
                        </h5>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
          )}
        </>
      );
    }
  }
}
export default withRouter(SupplierReportList);
